import { InvalidTargetError } from '../utils/errors';

export class CursorAction {
  constructor(el, config) {
    this.el = el;
    this.updateConfig(config);
    this.isActive = false;
    this.targets = CursorAction.CursorTargets(
      el,
      config.selector,
      config.parent
    );
  }

  updateConfig({ selector, isDisabled, parent }) {
    this.parent = parent || undefined;
    this.selector = selector || undefined;
    this.isDisabled = isDisabled || false;
  }

  activate() {
    if (this.isActive || this.isDisabled) return;
    this.isActive = true;

    this.targets
      .then(targets => {
        targets.forEach(target => {
          target.addEventListener('mouseover', this.onCursor.bind(this));
          target.addEventListener('mouseout', this.onCursorLost.bind(this));
          target.addEventListener('focus', this.onCursor.bind(this));
          target.addEventListener('blur', this.onCursorLost.bind(this));
        });
      })
      .catch(error => {
        if (error.name === 'InvalidTargetError') return;
        throw error;
      });
  }

  deactivate() {
    if (!this.isActive) return;
    this.isActive = false;
    this.targets
      .then(targets => {
        targets.forEach(target => {
          target.removeEventListener('mouseover', this.onCursor.bind(this));
          target.removeEventListener('mouseout', this.onCursorLost.bind(this));
          target.removeEventListener('focus', this.onCursor.bind(this));
          target.removeEventListener('blur', this.onCursorLost.bind(this));
        });
      })
      .catch(error => {
        if (error.name === 'InvalidTargetError') return;
        throw error;
      });
  }

  onCursor() {
    if (this.isDisabled) return;
    this.el.classList.add('has-mirror-hover-focus');
  }

  onCursorLost() {
    if (this.isDisabled) return;
    this.el.classList.remove('has-mirror-hover-focus');
  }

  static CursorTargets(el, selector, parent) {
    return new Promise((resolve, reject) => {
      const baseElement = parent ? el.closest(parent) : document;
      const targets = baseElement.querySelectorAll(selector);

      if (!targets.length) return reject(new InvalidTargetError());

      resolve(targets);
    });
  }
}
